import API from '~config/api';

import {
  ApiPromise,
  PaginationRequestParams,
  DataPaginateResponse,
  DataResponse,
  ErrorResponse,
} from '~globals/types';

import {
  AdminLogisticZone,
  AdminLogisticZoneCreateBody,
  AdminLogisticZoneFilter,
  AdminLogisticZoneUpdateBody,
} from './types';

export const ADMIN_LOGISTICS_ZONES_ENPOINTS = {
  getAdminLogistiscZones: '/api/v1/Admin/Zone',
  createAdminLogisticZone: '/api/v1/Admin/Zone',
  getAdminLogisticZoneById: (zoneId: string): string =>
    `/api/v1/Admin/Zone/${zoneId}`,
  searchAdminLogisticsZones: '/api/v1/Admin/Zone/search',
  updateAdminLogisticZone: '/api/v1/Admin/Zone',
  deleteAdminLogisticZone: (zoneId: string): string =>
    `/api/v1/Admin/Zone/${zoneId}`,
};

export const getAdminLogistiscZones = (): ApiPromise<
  DataPaginateResponse<AdminLogisticZone[]>,
  ErrorResponse
> =>
  API.get<DataPaginateResponse<AdminLogisticZone[]>, ErrorResponse>(
    ADMIN_LOGISTICS_ZONES_ENPOINTS.getAdminLogistiscZones,
  );

export const createAdminLogisticZone = (
  body: AdminLogisticZoneCreateBody,
): ApiPromise<DataResponse<AdminLogisticZone>, ErrorResponse> =>
  API.post<DataResponse<AdminLogisticZone>, ErrorResponse>(
    ADMIN_LOGISTICS_ZONES_ENPOINTS.createAdminLogisticZone,
    body,
  );

export const getAdminLogisticZoneById = (
  zoneId: string,
): ApiPromise<DataResponse<AdminLogisticZone>, ErrorResponse> =>
  API.get<DataResponse<AdminLogisticZone>, ErrorResponse>(
    ADMIN_LOGISTICS_ZONES_ENPOINTS.getAdminLogisticZoneById(zoneId),
  );

export const searchAdminLogisticsZones = ({
  pagination: { page, sizePerPage },
  filters,
}: PaginationRequestParams<AdminLogisticZoneFilter>): ApiPromise<
  DataPaginateResponse<AdminLogisticZone[]>,
  ErrorResponse
> =>
  API.post<DataPaginateResponse<AdminLogisticZone[]>, ErrorResponse>(
    ADMIN_LOGISTICS_ZONES_ENPOINTS.searchAdminLogisticsZones,
    { ...filters, pagination: { offset: page, size: sizePerPage } },
  );

export const updateAdminLogisticZone = (
  body: AdminLogisticZoneUpdateBody,
): ApiPromise<DataResponse<AdminLogisticZone>, ErrorResponse> =>
  API.put<DataResponse<AdminLogisticZone>, ErrorResponse>(
    ADMIN_LOGISTICS_ZONES_ENPOINTS.updateAdminLogisticZone,
    body,
  );

export const deleteAdminLogisticZone = (
  zoneId: string,
): ApiPromise<DataResponse<AdminLogisticZone>, ErrorResponse> =>
  API.delete<DataResponse<AdminLogisticZone>, ErrorResponse>(
    ADMIN_LOGISTICS_ZONES_ENPOINTS.deleteAdminLogisticZone(zoneId),
  );
